module.exports = "images/shadow.e85926c8cce69b581d52559e72c421c7.png";